import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Dispatch = ({ dispatchedHardware, onCompleted }) => {
  const [isDelivering, setIsDelivering] = React.useState(false);
  const [showCheckmark, setShowCheckmark] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleComplete = (row) => {
    setIsDelivering(true);
    onCompleted(row);
    setTimeout(() => {
      setIsDelivering(false);
      setShowCheckmark(true);
      setOpenDialog(true);
      setTimeout(() => {
        setShowCheckmark(false);
      }, 1000); // Duration for checkmark icon
    }, 1000); // Simulate animation duration
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Dispatch
      </Typography>
      <Grid container spacing={3}>
        {dispatchedHardware && dispatchedHardware.length > 0 ? (
          dispatchedHardware.map((row) => (
            <Grid item xs={12} key={row.id}>
              <Card sx={{ boxShadow: 3, border: '1px solid #1976d2' }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    {row['Customer Name']}
                  </Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Place:</strong> {row.Place}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Date:</strong> {row.Date}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Time:</strong> {row.Time}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Serial No:</strong> {row['Serial No']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>System Name:</strong> {row['System Name']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Contact Number:</strong> {row['Contact Number']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Customer ID:</strong> {row['Customer ID']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Address:</strong> {row.Address}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Customer Issue:</strong> {row['Customer Issue']}</Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    color="success"
                    onClick={() => handleComplete(row)}
                    disabled={isDelivering || showCheckmark}
                    sx={{
                      border: showCheckmark ? '1px solid green' : '1px solid transparent',
                      transition: 'border-color 0.3s ease-in-out',
                    }}
                  >
                    {isDelivering ? <CircularProgress size={20} color="inherit" /> : (showCheckmark ? <CheckCircleIcon /> : <LocalShippingIcon />)}
                    {!isDelivering && !showCheckmark && 'Completed'}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))
        ) : (
          <Typography variant="body1">No dispatched items.</Typography>
        )}
      </Grid>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Dispatch Completed</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The item has been successfully dispatched.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Dispatch;